// extracted by mini-css-extract-plugin
export default {"Faq":"Faq_Faq__tkoio","Faq_title":"Faq_Faq_title__FPtB-","Faq_subtitle":"Faq_Faq_subtitle__A4HBu"};